import { useSelector, useDispatch } from 'react-redux'

import { ModalForm } from 'components/common'
import BuildingApi, { pkField, getDetailUrl } from 'models/Building/api'
import { BuildingActions } from 'models/Building/slice'

import MainFieldSet from './MainFieldSet'


const BuildingForm = ({ mode = "list", initials }) => {
  const { activeForm, formDetailPK } = useSelector(state => state.building);

  const [apiGetFormDetail, apiGetFormDetailProps] = BuildingApi.endpoints.getBuildingFormDetail.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = BuildingApi.endpoints.updateBuilding.useMutation();

  const dispatch = useDispatch();

  const formDetail = apiGetFormDetailProps.data;

  const onFinish = (values) => {
    apiUpdate(values);
  };

  return (
    <ModalForm
      name="Building"
      withTabs={false}
      title={formDetailPK ? `Здание «${formDetail?.name}»`: 'Новое здание'}
      width={700}
      mode={mode}
      visible={activeForm === 'editForm'}

      pkField={pkField}
      formDetailPK={formDetailPK}

      getDetailUrl={getDetailUrl}
      apiGetFormDetail={apiGetFormDetail}
      apiGetFormDetailProps={apiGetFormDetailProps}
      apiUpdateProps={apiUpdateProps}
      api={BuildingApi}

      onFinish={onFinish}
      onClose={() => dispatch(BuildingActions.closeForm())}
      initialValues={{
        sort: 100,
        ...initials
      }}

      prepareFormValues={(detail) => {
        return {
          ...detail,
        }
      }}
    >
      <MainFieldSet />
    </ModalForm>
  );
}


export default BuildingForm
